import { render, staticRenderFns } from "./formEditDraftLog.vue?vue&type=template&id=48627192"
import script from "./formEditDraftLog.vue?vue&type=script&lang=js"
export * from "./formEditDraftLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports